import { render, staticRenderFns } from "./DiagBase.vue?vue&type=template&id=6746e0c7&"
import script from "./DiagBase.vue?vue&type=script&lang=js&"
export * from "./DiagBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports